import React from "react";

interface SignatureLoadingModalProps {
  isOpen: boolean;
}

export function SignatureLoadingModal({ isOpen }: SignatureLoadingModalProps) {
  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[9999] animate-fade-in" />

      {/* Modal */}
      <div className="fixed inset-0 z-[10000] flex items-center justify-center p-4 pointer-events-none">
        <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-md w-full pointer-events-auto animate-scale-in">
          <div className="text-center">
            {/* Icône animée */}
            <div className="relative mx-auto w-20 h-20 mb-6">
              <div className="absolute inset-0 border-4 border-indigo-200 rounded-full"></div>
              <div className="absolute inset-0 border-4 border-indigo-600 rounded-full border-t-transparent animate-spin"></div>
              <div className="absolute inset-0 flex items-center justify-center text-3xl">
                ✍️
              </div>
            </div>

            {/* Texte */}
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Ajout de votre signature numérique...
            </h3>
            <p className="text-sm text-gray-600 mb-4">
              Nous préparons votre devis signé avec toutes les informations de traçabilité.
            </p>

            {/* Progress bar animée */}
            <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
              <div className="h-full bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full animate-progress"></div>
            </div>

            <p className="text-xs text-gray-500 mt-4">
              Cela ne prend que quelques secondes...
            </p>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fade-in {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scale-in {
          from {
            transform: scale(0.9);
            opacity: 0;
          }
          to {
            transform: scale(1);
            opacity: 1;
          }
        }

        @keyframes progress {
          0% {
            width: 0%;
          }
          100% {
            width: 100%;
          }
        }

        .animate-fade-in {
          animation: fade-in 0.3s ease-out;
        }

        .animate-scale-in {
          animation: scale-in 0.3s ease-out;
        }

        .animate-progress {
          animation: progress 3s ease-in-out;
        }
      `}</style>
    </>
  );
}

